import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c167d868&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c167d868')) {
      api.createRecord('c167d868', component.options)
    } else {
      api.reload('c167d868', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c167d868&", function () {
      api.rerender('c167d868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fullGiftOrderSalesStatistic/index.vue"
export default component.exports